import React from 'react';
import Icon from '../../../components/AppIcon';

const KnowledgeAreaCard = ({ area, questionsAttempted, totalQuestions, averageScore, lastPracticed }) => {
  const percentage = totalQuestions > 0 ? Math.round((questionsAttempted / totalQuestions) * 100) : 0;
  
  const getProficiencyLevel = (score) => {
    if (score >= 85) return { label: 'Expert', color: 'text-success', bg: 'bg-success/10' };
    if (score >= 70) return { label: 'Proficient', color: 'text-primary', bg: 'bg-primary/10' };
    if (score >= 50) return { label: 'Developing', color: 'text-warning', bg: 'bg-warning/10' };
    return { label: 'Beginner', color: 'text-error', bg: 'bg-error/10' };
  };

  const proficiency = getProficiencyLevel(averageScore);

  return (
    <div className="bg-card rounded-lg p-4 md:p-5 border border-border transition-smooth hover:shadow-elevation-2">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1 min-w-0">
          <h4 className="text-sm md:text-base font-semibold text-foreground mb-1 line-clamp-2">
            {area}
          </h4>
          <p className="text-xs md:text-sm text-muted-foreground">
            {questionsAttempted} / {totalQuestions} questions
          </p>
        </div>
        <div className={`px-2 py-1 rounded-md ${proficiency?.bg} flex-shrink-0 ml-2`}>
          <span className={`text-xs font-medium ${proficiency?.color} whitespace-nowrap`}>
            {proficiency?.label}
          </span>
        </div>
      </div>
      <div className="space-y-2">
        <div className="w-full h-1.5 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full bg-primary rounded-full transition-all duration-500"
            style={{ width: `${percentage}%` }}
          />
        </div>

        <div className="flex items-center justify-between text-xs md:text-sm">
          <div className="flex items-center gap-1 text-muted-foreground">
            <Icon name="Target" size={14} />
            <span className="data-text">{averageScore}% avg</span>
          </div>
          <span className="text-muted-foreground">{lastPracticed}</span>
        </div>
      </div>
    </div>
  );
};

export default KnowledgeAreaCard;